import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const actionSelector = ({ action }: ReducerState) => action;
export const actionLoadingSelector = createSelector(
  actionSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
